import React, { useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Label from "components/Input/Label/Label";
import Placeholder from "components/Input/Placeholder/Placeholder";
import { menuItemSx, selectionSx } from "lib/muiStyle/muiStyle";
import c from "lib/style/colorVar.scss";
import HelperMessage from "components/Input/HelperMessage/HelperMessage";

const Selection = ({
  label,
  mandatory,
  placeholder,
  errorMessage,
  noErrorMessage,
  defaultValue,
  selectionValue,
  multiple,
  onchangeFn,
  onfocusFn,
  onblurFn,
  sxParams = {},
  options,
  disabled,
  divStyle
}) => {
  const [focus, setFocus] = useState(false);
  const { selectionFocus, selectionError } = sxParams;
  return (
    <div style={{ position: "relative", ...divStyle }}>
      <Label label={label} mandatory={mandatory} />
      <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
        <Select
          style={disabled ? { background: c.disabledFieldBg } : {}}
          size={"small"}
          disabled={disabled}
          defaultValue={defaultValue}
          value={selectionValue}
          multiple={multiple}
          onChange={onchangeFn}
          onFocus={onfocusFn ?? (() => setFocus(true))}
          onBlur={onblurFn ?? (() => setFocus(false))}
          displayEmpty
          renderValue={
            selectionValue != ""
              ? undefined
              : () => {
                  return <Placeholder>{placeholder}</Placeholder>;
                }
          }
          sx={() =>
            selectionSx(selectionFocus ?? focus, selectionError, disabled)
          }
          MenuProps={{
            sx: {
              "& .MuiMenu-paper": {
                maxWidth: "1px",
                maxHeight: "350px",
                overflow: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ddd #fff",
              },
            },
          }}
        >
          {options.map((option) => {
            return (
              <MenuItem
                key={option.key}
                value={option.value}
                sx={() => menuItemSx()}
              >
                {option.title}
              </MenuItem>
            );
          })}
        </Select>
      </div>
      {!noErrorMessage && (
        <HelperMessage message={selectionError && errorMessage} />
      )}
    </div>
  );
};

export default React.memo(Selection);
